import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "fee_list"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("h2", null, "報酬履歴", -1);
const _hoisted_5 = { class: "inner" };
const _hoisted_6 = { class: "nav_top" };
const _hoisted_7 = { class: "d_navi" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-angle-left" }, null, -1);
const _hoisted_9 = [
    _hoisted_8
];
const _hoisted_10 = { class: "year" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-angle-right" }, null, -1);
const _hoisted_12 = [
    _hoisted_11
];
const _hoisted_13 = { class: "fee_box" };
const _hoisted_14 = { class: "t_base" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "相談終了日"),
        /*#__PURE__*/ _createElementVNode("th", null, "振込日"),
        /*#__PURE__*/ _createElementVNode("th", null, "件名"),
        /*#__PURE__*/ _createElementVNode("th", null, "順位"),
        /*#__PURE__*/ _createElementVNode("th", null, "報酬額"),
        /*#__PURE__*/ _createElementVNode("th", null, "送金額")
    ])
], -1);
const _hoisted_16 = { key: 0 };
const _hoisted_17 = { key: 1 };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("td", null, null, -1);
const _hoisted_19 = {
    key: 0,
    class: "pay"
};
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("td", null, null, -1);
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("td", null, null, -1);
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("td", null, null, -1);
const _hoisted_23 = { class: "odd" };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("td", null, null, -1);
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("td", null, null, -1);
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("td", null, "未送金残高", -1);
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("td", null, null, -1);
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("td", null, null, -1);
const _hoisted_29 = { class: "sub_t" };
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_31 = { class: "nav_under" };
const _hoisted_32 = { class: "d_navi" };
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-angle-left" }, null, -1);
const _hoisted_34 = [
    _hoisted_33
];
const _hoisted_35 = { class: "year" };
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-angle-right" }, null, -1);
const _hoisted_37 = [
    _hoisted_36
];
import { Link } from '@inertiajs/inertia-vue3';
import { Inertia } from '@inertiajs/inertia';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Formatter from '@util/Formatter';
export default /*#__PURE__*/ _defineComponent({
    __name: 'fee_list',
    props: {
        common: null,
        reward_history: null,
        transfer_group: null,
        year: null,
        untransfer_amount: null
    },
    setup(__props) {
        const props = __props;
        const goReward = (step) => {
            const year = Number.parseInt(props.year);
            if (year === 1 && step === -1)
                return;
            if (Number.isNaN(year))
                return;
            Inertia.get(route('mentor.reward_history.index'), { year: year + step });
        };
        const showRank = (rank) => {
            if (rank)
                return rank;
            else {
                if (rank === null)
                    return '';
                if (rank === undefined)
                    return '';
            }
            return '';
        };
        const showUntransferAmount = () => {
            return `${props.untransfer_amount.toLocaleString()}円`;
        };
        const showPaidAmount = (payment_history_id) => {
            let total = 0;
            const targetGroup = props.transfer_group.find(item => item.payment_history_id === payment_history_id);
            if (targetGroup) {
                targetGroup.reward_ids.map((id) => {
                    var _a;
                    let targetHistory = props.reward_history.find(history => (history.id == id) && (history.is_pay == true));
                    if (targetHistory)
                        total += (_a = targetHistory.reward_amount) !== null && _a !== void 0 ? _a : 0;
                });
            }
            return `${total.toLocaleString()}円`;
        };
        const showFee = (payment_history_id) => {
            const targetGroup = props.transfer_group.find(item => item.payment_history_id === payment_history_id);
            if (targetGroup) {
                let fee = targetGroup.transfer_fee;
                return `${fee.toLocaleString()}円`;
            }
            else {
                return '';
            }
        };
        const showPayedDate = (payment_history_id) => {
            const targetGroup = props.transfer_group.find(item => item.payment_history_id === payment_history_id);
            if (targetGroup) {
                let payedDate = targetGroup.captured_date;
                return payedDate;
            }
            else {
                return '';
            }
        };
        const paidCount = () => { var _a, _b; return ((_b = (_a = props === null || props === void 0 ? void 0 : props.reward_history) === null || _a === void 0 ? void 0 : _a.filter((value) => value.is_pay)) !== null && _b !== void 0 ? _b : []).length; };
        //check the year is valid
        const validYear = Number.parseInt(props.year) && Number.parseInt(props.year) > 0;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("ul", _hoisted_7, [
                                        _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (goReward(-1)), ["prevent"]))
                                            }, _hoisted_9)
                                        ]),
                                        _createElementVNode("li", _hoisted_10, _toDisplayString(_unref(validYear) ? props.year : new Date().getFullYear()), 1),
                                        _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (goReward(1)), ["prevent"]))
                                            }, _hoisted_12)
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("table", _hoisted_14, [
                                        _hoisted_15,
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.reward_history, (history, index) => {
                                                var _a;
                                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                    _createElementVNode("tr", null, [
                                                        _createElementVNode("td", null, _toDisplayString(history.ended_at), 1),
                                                        _createElementVNode("td", null, _toDisplayString(showPayedDate(history.payment_history_id)), 1),
                                                        (history.question_id)
                                                            ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                                                                _createVNode(_unref(Link), {
                                                                    href: `/question/${history.question_id}`
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(history.subject), 1)
                                                                    ]),
                                                                    _: 2
                                                                }, 1032, ["href"])
                                                            ]))
                                                            : (_openBlock(), _createElementBlock("td", _hoisted_17, _toDisplayString(history.subject), 1)),
                                                        _createElementVNode("td", null, _toDisplayString(showRank(history.rank)), 1),
                                                        _createElementVNode("td", null, _toDisplayString(_unref(Formatter).formatAmount((_a = history.reward_amount) !== null && _a !== void 0 ? _a : null)), 1),
                                                        _hoisted_18
                                                    ]),
                                                    (typeof history.payment_history_id === 'number')
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            ((props.reward_history[index + 1] &&
                                                                history.payment_history_id !==
                                                                    props.reward_history[index + 1].payment_history_id) ||
                                                                index + 1 === props.reward_history.length)
                                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                                                                    _hoisted_20,
                                                                    _createElementVNode("td", null, _toDisplayString(showPayedDate(history.payment_history_id)), 1),
                                                                    _createElementVNode("td", null, "送金 (うち、振込手数料" + _toDisplayString(showFee(history.payment_history_id)) + ")", 1),
                                                                    _hoisted_21,
                                                                    _hoisted_22,
                                                                    _createElementVNode("td", null, _toDisplayString(showPaidAmount(history.payment_history_id)), 1)
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ], 64))
                                                        : _createCommentVNode("", true)
                                                ], 64));
                                            }), 256)),
                                            _createElementVNode("tr", _hoisted_23, [
                                                _hoisted_24,
                                                _hoisted_25,
                                                _hoisted_26,
                                                _hoisted_27,
                                                _createElementVNode("td", null, _toDisplayString(showUntransferAmount()), 1),
                                                _hoisted_28
                                            ])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("p", _hoisted_29, [
                                    _createTextVNode(" ※お振込み条件は、報酬残高の合計が5,000円以上で月末締め翌月末日払いです。"),
                                    _hoisted_30,
                                    _createTextVNode("※振込手数料として" + _toDisplayString(__props.common.transfer_fee) + "円をお客様ご負担とさせて頂きます。 ", 1)
                                ]),
                                _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("ul", _hoisted_32, [
                                        _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (goReward(-1)), ["prevent"]))
                                            }, _hoisted_34)
                                        ]),
                                        _createElementVNode("li", _hoisted_35, _toDisplayString(_unref(validYear) ? props.year : new Date().getFullYear()), 1),
                                        _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                                onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (goReward(1)), ["prevent"]))
                                            }, _hoisted_37)
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
